// removed by extract-text-webpack-plugin
module.exports = {"info":"info__1kNqb"};


//////////////////
// WEBPACK FOOTER
// ./components/info/style.css
// module id = B7O8
// module chunks = 3